RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.CompanyBase = Backbone.Model.extend({
        toViewJSON: function () {
            let tooltip;
            let companyClass;
            const me = this;
            let icon = '';
            let abbr = '';
            const json = me.toJSON();
            icon = RivalIQ.utils.companyDisplay.getIcon(json);
            abbr = RivalIQ.utils.companyDisplay.getAbbreviation(json);
            const description = RivalIQ.utils.companyDisplay.getDescription(json);

            json.icon = icon;
            json.abbr = abbr;
            json.tooltip = tooltip;
            json.companyClass = companyClass;
            json.description = description;
            json.company_name = json.name || '';

            return json;
        }
    });
});
